import { Alert, AlertTitle, Box } from '@mui/material';
import PropTypes from 'prop-types';

import { FIELD_HEADERS } from '../utils/productPricingColumns';

// Lists what a refused save needs fixed, one line per flagged cell. It shrinks as each cell is
// edited, since the page drops a cell's flag as soon as it changes.
const SaveErrorsAlert = ({ errors, rows }) => {
  if (errors.size === 0) return null;

  return (
    <Alert severity='error'>
      <AlertTitle>{`Not saved: ${errors.size} ${
        errors.size === 1 ? 'problem' : 'problems'
      } to fix`}</AlertTitle>
      <Box component='ul' sx={{ m: 0, pl: 2 }}>
        {[...errors].map(([key, message]) => {
          const [ndc, field] = key.split(':');
          const name = rows.find((row) => row.ndc === ndc)?.name;
          return (
            <li key={key}>
              {`NDC ${ndc}${name ? ` (${name})` : ''}, ${FIELD_HEADERS[field] ?? field}: ${message}`}
            </li>
          );
        })}
      </Box>
    </Alert>
  );
};

SaveErrorsAlert.propTypes = {
  errors: PropTypes.instanceOf(Map).isRequired,
  rows: PropTypes.arrayOf(PropTypes.shape({ ndc: PropTypes.string, name: PropTypes.string }))
    .isRequired,
};

export default SaveErrorsAlert;
